import { render, staticRenderFns } from "./UndeliveredDocuments.vue?vue&type=template&id=71e48c54&"
import script from "./UndeliveredDocuments.vue?vue&type=script&lang=js&"
export * from "./UndeliveredDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports